import { DefaultValues, FieldValues, useForm } from 'react-hook-form';

export interface UseFiltersFormParams<TFieldValues extends FieldValues> {
  defaultValues?: DefaultValues<TFieldValues>;
}

export const useFiltersForm = <TFieldValues extends FieldValues = FieldValues>({ defaultValues }: UseFiltersFormParams<TFieldValues> = {}) => {
  const form = useForm<TFieldValues>({ mode: 'onChange', defaultValues });

  return form;
};
